//@flow
import { connect } from 'react-redux';
import { initStripePaymentMean } from '../../../../../modules/Payment';
import { StripePayment } from './StripePayment';

const mapDispatchToProps = {
  initStripePaymentMean: initStripePaymentMean,
};

export default connect(null, mapDispatchToProps)(StripePayment);
